import React, { useEffect, useState } from "react";
import {
  Sidebar,
  Menu,
  MenuItem,
  useProSidebar,
  sidebarClasses,
  MenuItemStyles,
} from "react-pro-sidebar";
import "../SideMenu/SideMenu.css";
import logo from "../../../img/Looog 1.png";
import man from "../../../img/daseman.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userView } from "../../../Helper/Redux/API";

function Sidemenu() {
  const { collapseSidebar, toggleSidebar, collapsed, toggled, broken, rtl } =
    useProSidebar();
  const { pathname } = useLocation();
  const history = useNavigate();
  const dispatch = useDispatch();
  const user_Role = localStorage.getItem("UserName");
  const user_Lastname = localStorage.getItem("lastName");
  const userroleid = localStorage.getItem("Roleid");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const logout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("UserName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("Roleid");
    localStorage.removeItem("id");
    localStorage.removeItem("step2");
    localStorage.removeItem("step3");
    localStorage.removeItem("step4");
    localStorage.removeItem("step5");
    localStorage.removeItem("step6");
    localStorage.removeItem("step7");
    localStorage.removeItem("step8");
    localStorage.removeItem("step9");
    localStorage.removeItem("Rightear2KHz");
    localStorage.removeItem("Rightear4KHz");
    localStorage.removeItem("Leftear1KHz");
    localStorage.removeItem("Leftear6KHz");
    localStorage.removeItem("Measuretest");
    localStorage.removeItem("result_test_id");
    localStorage.removeItem("Rightear500Hz");
    localStorage.removeItem("rightear1KHz");
    localStorage.removeItem("Leftear500Hz");
    localStorage.removeItem("Leftear2000KHz");
    // localStorage.removeItem("testtrue");
    history("/");
  };

  const [roleid, setRoleId] = useState();

  // const getviewuser = () => {
  //   const data = {
  //     id: localStorage.getItem("id"),
  //   };
  //   try {
  //     dispatch(userView(data)).then((res) => {
  //       if (res?.payload?.status === true) {
  //         const RoleId = res.payload.data.roles;
  //         setRoleId(RoleId[0].id);
  //         console.log(RoleId[0].id);
  //       }
  //     });
  //   } catch (error) {
  //     console.log(error, "error");
  //   }
  // };

  // useEffect(() => {
  //   getviewuser();
  // }, []);

  return (
    <div className="sider_bg">
      <Sidebar
        rootStyles={{
          [`.${sidebarClasses.container}`]: {
            backgroundColor: "#ffffff00",
          },
        }}
      >
        <div className="pro_space">
          <div className="user_profile">
            <div>
              <Link to="/">
                <img src={logo} className="img-fluid" alt="log" />
              </Link>{" "}
            </div>
            {/* 
            <div className="user_name">
              <h6>
                {user_Role}&nbsp; {user_Lastname}{" "}
              </h6>
              <p>User</p>
            </div> */}
          </div>
        </div>
        <div className="menu_space">
          {/* {userroleid == "2" ? ( */}
          <>
            {" "}
            <Menu>
              <Link className={pathname === "/" ? "active" : ""} to="/">
                <MenuItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                  >
                    <path
                      d="M17.245 5.17014C16.017 3.90187 13.9829 3.90186 12.7549 5.17013L6.75682 11.3648C6.41234 11.7206 6.18086 12.1703 6.09154 12.6574C5.36309 16.6299 5.30932 20.6967 5.93249 24.687L6.15311 26.0998C6.2228 26.546 6.60713 26.875 7.05876 26.875H11.25C11.5951 26.875 11.875 26.5952 11.875 26.25V17.5H18.125V26.25C18.125 26.5952 18.4048 26.875 18.75 26.875H22.9411C23.3927 26.875 23.7771 26.546 23.8468 26.0998L24.0674 24.687C24.6905 20.6967 24.6368 16.6299 23.9083 12.6574C23.819 12.1703 23.5875 11.7206 23.2431 11.3648L17.245 5.17014Z"
                      fill="#fff"
                    ></path>
                  </svg>
                  <span className="hide_text">HOME</span>
                </MenuItem>
              </Link>
              <Link
                className={pathname === "/Calendar" ? "active" : ""}
                to="/Calendar"
              >
                <MenuItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="20"
                    viewBox="0 0 18 20"
                    fill="none"
                  >
                    <path
                      d="M11.5 16C10.8 16 10.2083 15.7583 9.725 15.275C9.24167 14.7917 9 14.2 9 13.5C9 12.8 9.24167 12.2083 9.725 11.725C10.2083 11.2417 10.8 11 11.5 11C12.2 11 12.7917 11.2417 13.275 11.725C13.7583 12.2083 14 12.8 14 13.5C14 14.2 13.7583 14.7917 13.275 15.275C12.7917 15.7583 12.2 16 11.5 16ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18Z"
                      fill="#F9F9FA"
                    />
                  </svg>
                  <span className="hide_text">Appointment</span>
                </MenuItem>
              </Link>
              <Link
                className={pathname === "/Invoice" ? "active" : ""}
                to="/Invoice"
              >
                <MenuItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.103531 0.142585C0.0606926 0.0997467 0.0265913 0.0514805 0.00122673 0L0.00122679 21.1293C-0.0316419 22.214 0.583899 24.3833 3.30902 24.3833C4.38771 24.3803 6.54509 23.7253 6.54509 21.1293V18.8434C6.47936 18.5237 6.54509 17.8842 7.33394 17.8842H18.6737V0.170503L16.0067 2.83747C15.7966 3.04752 15.4561 3.04752 15.246 2.83747L12.5512 0.142585C12.5384 0.1298 12.5264 0.116532 12.5151 0.102839C12.5039 0.116532 12.4919 0.1298 12.4791 0.142585L9.78423 2.83747C9.57418 3.04752 9.23363 3.04752 9.02359 2.83747L6.3287 0.142585C6.3154 0.129283 6.30294 0.115459 6.29132 0.101177C6.27971 0.115459 6.26725 0.129283 6.25395 0.142585L3.55906 2.83747C3.34901 3.04752 3.00846 3.04752 2.79842 2.83747L0.103531 0.142585ZM7.91662 19.1303V21.7031C7.85088 22.2887 7.49709 23.6519 6.60784 24.4192H21.0581C22.4356 24.5417 25.1512 23.6555 24.9934 19.1303H7.91662Z"
                      fill="#F9F9FA"
                    />
                  </svg>

                  <span className="hide_text">Invoice</span>
                </MenuItem>
              </Link>
              <Link
                className={pathname === "/MyHistory" ? "active" : ""}
                to="/MyHistory"
              >
                <MenuItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.3281 23.1719C15.5469 24.3906 17.0208 25 18.75 25C20.4792 25 21.9531 24.3906 23.1719 23.1719C24.3906 21.9531 25 20.4792 25 18.75C25 17.0208 24.3906 15.5469 23.1719 14.3281C21.9531 13.1094 20.4792 12.5 18.75 12.5C17.0208 12.5 15.5469 13.1094 14.3281 14.3281C13.1094 15.5469 12.5 17.0208 12.5 18.75C12.5 20.4792 13.1094 21.9531 14.3281 23.1719ZM17.5 7.5H5V5H17.5V7.5ZM2.5 22.5H10.8438C10.5312 21.875 10.3125 21.2656 10.1875 20.6719C10.0625 20.0781 10 19.4375 10 18.75C10 18.5208 10.0052 18.3073 10.0156 18.1094C10.026 17.9115 10.0521 17.7083 10.0938 17.5H5V15H10.8438C11.0729 14.5208 11.3385 14.0729 11.6406 13.6562C11.9427 13.2396 12.2812 12.8542 12.6562 12.5H5V10H17.5V10.0938C17.7083 10.0521 17.9115 10.026 18.1094 10.0156C18.3073 10.0052 18.5208 10 18.75 10C19.4167 10 20.0573 10.0729 20.6719 10.2188C21.2865 10.3646 21.8958 10.5833 22.5 10.875V2.5C22.5 1.8125 22.2552 1.22396 21.7656 0.734375C21.276 0.244792 20.6875 0 20 0H2.5C1.8125 0 1.22396 0.244792 0.734375 0.734375C0.244792 1.22396 0 1.8125 0 2.5V20C0 20.6875 0.244792 21.276 0.734375 21.7656C1.22396 22.2552 1.8125 22.5 2.5 22.5ZM15 18.114L17.9019 21.25L22.5 16.2588L21.3556 15L17.8815 18.7544L16.1444 16.8772L15 18.114Z"
                      fill="#F9F9FA"
                    />
                  </svg>

                  <span className="hide_text">My History</span>
                </MenuItem>
              </Link>
              <Link
                className={pathname === "/Profile" ? "active" : ""}
                to="/Profile"
              >
                <MenuItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1118_128)">
                      <path
                        d="M15.625 25C15.625 25.0094 15.625 25.0177 15.625 25.0271H9.37395C9.37395 25.0177 9.37395 25.0094 9.37395 25C9.37395 23.2771 10.776 21.875 12.499 21.875C14.2219 21.875 15.624 23.2771 15.624 25H15.625ZM15.5448 8.3604H22.3573C21.9958 7.40936 21.4406 6.53436 20.7 5.79374L17.0708 2.16249C16.3292 1.42186 15.4542 0.866652 14.5031 0.506236V7.31874C14.5031 7.89269 14.9698 8.3604 15.5448 8.3604ZM22.8365 10.9489V19.8187C22.8365 22.6635 20.5427 24.9833 17.7073 25.026C17.7073 25.0177 17.7073 25.0094 17.7073 25C17.7073 22.1281 15.3708 19.7917 12.499 19.7917C9.62708 19.7917 7.29062 22.1281 7.29062 25C7.29062 25.0094 7.29062 25.0177 7.29062 25.0271H7.20937C4.3375 25.0271 2.00104 22.6906 2.00104 19.8187V5.2354C2.00312 2.36353 4.33958 0.0270691 7.21145 0.0270691H11.9146C12.0844 0.0270691 12.2521 0.0406108 12.4198 0.0520691V7.31874C12.4198 9.04165 13.8219 10.4437 15.5448 10.4437H22.8115C22.8229 10.6114 22.8365 10.7792 22.8365 10.9489ZM16.1458 15.1042C16.1458 13.0937 14.5104 11.4583 12.5 11.4583C10.4896 11.4583 8.85416 13.0937 8.85416 15.1042C8.85416 17.1146 10.4896 18.75 12.5 18.75C14.5104 18.75 16.1458 17.1146 16.1458 15.1042ZM12.5 13.5417C11.6385 13.5417 10.9375 14.2427 10.9375 15.1042C10.9375 15.9656 11.6385 16.6667 12.5 16.6667C13.3615 16.6667 14.0625 15.9656 14.0625 15.1042C14.0625 14.2427 13.3615 13.5417 12.5 13.5417Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1118_128">
                        <rect width="25" height="25" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <span className="hide_text">Profile</span>
                </MenuItem>
              </Link>

              <Link
                className={pathname === "/MyPoints" ? "active" : ""}
                to="/MyPoints"
              >
                <MenuItem>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.3281 23.1719C15.5469 24.3906 17.0208 25 18.75 25C20.4792 25 21.9531 24.3906 23.1719 23.1719C24.3906 21.9531 25 20.4792 25 18.75C25 17.0208 24.3906 15.5469 23.1719 14.3281C21.9531 13.1094 20.4792 12.5 18.75 12.5C17.0208 12.5 15.5469 13.1094 14.3281 14.3281C13.1094 15.5469 12.5 17.0208 12.5 18.75C12.5 20.4792 13.1094 21.9531 14.3281 23.1719ZM17.5 7.5H5V5H17.5V7.5ZM2.5 22.5H10.8438C10.5312 21.875 10.3125 21.2656 10.1875 20.6719C10.0625 20.0781 10 19.4375 10 18.75C10 18.5208 10.0052 18.3073 10.0156 18.1094C10.026 17.9115 10.0521 17.7083 10.0938 17.5H5V15H10.8438C11.0729 14.5208 11.3385 14.0729 11.6406 13.6562C11.9427 13.2396 12.2812 12.8542 12.6562 12.5H5V10H17.5V10.0938C17.7083 10.0521 17.9115 10.026 18.1094 10.0156C18.3073 10.0052 18.5208 10 18.75 10C19.4167 10 20.0573 10.0729 20.6719 10.2188C21.2865 10.3646 21.8958 10.5833 22.5 10.875V2.5C22.5 1.8125 22.2552 1.22396 21.7656 0.734375C21.276 0.244792 20.6875 0 20 0H2.5C1.8125 0 1.22396 0.244792 0.734375 0.734375C0.244792 1.22396 0 1.8125 0 2.5V20C0 20.6875 0.244792 21.276 0.734375 21.7656C1.22396 22.2552 1.8125 22.5 2.5 22.5ZM15 18.114L17.9019 21.25L22.5 16.2588L21.3556 15L17.8815 18.7544L16.1444 16.8772L15 18.114Z"
                      fill="#F9F9FA"
                    />
                  </svg>

                  <span className="hide_text">My Points</span>
                </MenuItem>
              </Link>
            </Menu>
            {/* </>
          ) : ( */}
            {/* <>
              {" "}
              <Menu>
                <Link
                  className={pathname === "/Calendar" ? "active" : ""}
                  to="/Calendar"
                >
                  <MenuItem>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="20"
                      viewBox="0 0 18 20"
                      fill="none"
                    >
                      <path
                        d="M11.5 16C10.8 16 10.2083 15.7583 9.725 15.275C9.24167 14.7917 9 14.2 9 13.5C9 12.8 9.24167 12.2083 9.725 11.725C10.2083 11.2417 10.8 11 11.5 11C12.2 11 12.7917 11.2417 13.275 11.725C13.7583 12.2083 14 12.8 14 13.5C14 14.2 13.7583 14.7917 13.275 15.275C12.7917 15.7583 12.2 16 11.5 16ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18Z"
                        fill="#F9F9FA"
                      />
                    </svg>
                    Appointment
                  </MenuItem>
                </Link>
                <Link
                  className={pathname === "/INVOICE" ? "active" : ""}
                  to="/INVOICE"
                >
                  <MenuItem>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.103531 0.142585C0.0606926 0.0997467 0.0265913 0.0514805 0.00122673 0L0.00122679 21.1293C-0.0316419 22.214 0.583899 24.3833 3.30902 24.3833C4.38771 24.3803 6.54509 23.7253 6.54509 21.1293V18.8434C6.47936 18.5237 6.54509 17.8842 7.33394 17.8842H18.6737V0.170503L16.0067 2.83747C15.7966 3.04752 15.4561 3.04752 15.246 2.83747L12.5512 0.142585C12.5384 0.1298 12.5264 0.116532 12.5151 0.102839C12.5039 0.116532 12.4919 0.1298 12.4791 0.142585L9.78423 2.83747C9.57418 3.04752 9.23363 3.04752 9.02359 2.83747L6.3287 0.142585C6.3154 0.129283 6.30294 0.115459 6.29132 0.101177C6.27971 0.115459 6.26725 0.129283 6.25395 0.142585L3.55906 2.83747C3.34901 3.04752 3.00846 3.04752 2.79842 2.83747L0.103531 0.142585ZM7.91662 19.1303V21.7031C7.85088 22.2887 7.49709 23.6519 6.60784 24.4192H21.0581C22.4356 24.5417 25.1512 23.6555 24.9934 19.1303H7.91662Z"
                        fill="#F9F9FA"
                      />
                    </svg>
                    Patients
                  </MenuItem>
                </Link>
              </Menu> */}
          </>
          {/* )} */}
        </div>
        <div className="das_img">
          <img src={man} alt="man img" className="img-fluid" />
          <button onClick={logout} className="Logout btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
            >
              <path
                d="M2.65003 18.9609C1.91161 18.9609 1.28533 18.7038 0.7712 18.1897C0.257067 17.6756 0 17.0493 0 16.3109V2.65003C0 1.91161 0.257067 1.28533 0.7712 0.771201C1.28533 0.257067 1.91161 0 2.65003 0H9.5935V2.65003H2.65003V16.3109H9.5935V18.9609H2.65003ZM13.2968 15.1588L11.4554 13.2707L13.9206 10.8055H6.3674V8.15543H13.9206L11.4554 5.69023L13.2968 3.80215L18.9609 9.48045L13.2968 15.1588Z"
                fill="#F9F9FA"
              />
            </svg>{" "}
            LOG OUT
          </button>
        </div>
      </Sidebar>

      <main className="Main_btn">
        <button className="side_bar_btn_icon" onClick={() => collapseSidebar()}>
          <i className="fa fa-bars" aria-hidden="true"></i>
        </button>
      </main>
    </div>
  );
}

export default Sidemenu;
